import React from 'react'
import moment from 'moment'
import { get, isEmpty, join, unescape } from 'lodash'

import { getFormattedEventTime } from '../../utilities/events/getFormattedEventTime'
import labels from '../../configuration/labels'
import placeholderImage from '../../assets/images/brand-placeholder.jpg'

const EventCard = ({ event }) => {
  const startDate = moment(get(event, 'activeDates.startDate', null))
  const endDate = moment(get(event, 'activeDates.endDate', null))
  const {
    categories,
    flagColor,
    flagText,
    isInternalLink,
    isBookingLinkInternal,
    isLocationLinkInternal,
    location,
    locationLink,
    marketingLink,
    bookingLink,
    title
  } = event

  const formattedEventTime = getFormattedEventTime(startDate, endDate)
  const formattedStartDate = moment(startDate).format('ll')

  return (
    <div className="event-card">
      <div className="event-card__header">
        <div className="event-banner__dates">
          <span className="date">
            <span className="month">{startDate?.format('MMM')}</span>
            <span className="day">{startDate?.format('DD')}</span>
          </span>
          {!startDate.startOf('day').isSame(endDate.startOf('day')) && (
            <>
              <span className="date-spacer">-</span>
              <span className="date">
                <span className="month">{endDate?.format('MMM')}</span>
                <span className="day">{endDate?.format('DD')}</span>
              </span>
            </>
          )}
        </div>
        <div className="event-banner__categories">
          {categories && !isEmpty(categories) && (
            <span className="category">{unescape(join(categories, ', '))}</span>
          )}
          {flagText && (
            <span
              className="flag"
              style={
                flagColor && {
                  color: flagColor
                }
              }
            >
              {flagText}
            </span>
          )}
        </div>
        <img
          className="event-image"
          alt={get(event, 'image.alt', 'event-image')}
          src={get(event, 'image.path', placeholderImage)}
        />
      </div>
      <div className="event-card__body">
        <h4 className="title">{title}</h4>
        <p className="description line-clamp">
          {get(event, 'description')}
        </p>
        <div className="event-links">
          {bookingLink && (
            <a
              className="btn link-view-details booking-link"
              href={bookingLink}
              target={isBookingLinkInternal ? '_self' : '_blank'}
              rel="noopener noreferrer"
            >
              {get(labels, 'eventCardsBookNow', 'Book Today')}
            </a>
          )}
          <a
            className="btn link-view-details"
            href={marketingLink}
            target={isInternalLink ? '_self' : '_blank'}
            rel="noopener noreferrer"
          >
            {get(labels, 'eventCardsCtaLearnMore', 'Learn More')}
          </a>
        </div>
        <div className="section-divider" />
        <div className="event-schedule">
          <div>
            {formattedStartDate && <span className="event-time">{formattedStartDate}</span>}
            {formattedStartDate && formattedEventTime && <span className="vertical-divider">|</span>}
            {formattedEventTime && <span className="event-time">{formattedEventTime}</span>}
          </div>
          {location && (
            <>
              {locationLink ? (
                <a
                  className="link event-location"
                  href={locationLink}
                  target={isLocationLinkInternal ? '_self' : '_blank'}
                  rel="noopener noreferrer"
                >
                  {location}
                </a>
              ) : (
                <span className="event-location">{location}</span>
              )}
            </>
          )}

        </div>
      </div>
    </div>
  )
}
export default EventCard
